var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2, _rect3, _path14, _path15, _path16, _path17, _rect4, _path18, _path19, _path20, _path21, _path22, _rect5, _path23, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradingBotLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 142,
    viewBox: "0 0 145 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68632 38.0537C7.09693 26.685 15.7261 17.7459 20.1461 13.6904C33.1043 4.50176 39.9835 3.51293 48.6605 2.26569L48.8311 2.24116C62.3441 0.29828 92.1623 0.477272 104.538 4.14715C120.008 8.73451 128.848 17.9092 134.072 27.4828C139.296 37.0564 145.323 52.2146 141.506 82.531C138.452 106.784 125.634 115.64 114.785 121.623L96.9036 130.798L75.4065 140.372C65.361 136.316 41.4528 126.051 26.1836 117.435C7.09718 106.665 3.48083 87.3178 2.47631 82.531C0.341718 72.3591 2.08733 50.3108 4.68632 38.0537Z",
    fill: "url(#paint0_linear_1777_12328)",
    stroke: "black",
    strokeWidth: 1.36667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9769 82.3086H3.35156L3.95216 85.3535L4.75295 88.8045L5.95414 92.4584L7.55572 96.3153C18.2863 96.4777 26.6413 96.2476 27.7757 95.7063C29.8578 92.9456 29.3773 85.0829 28.9769 82.3086Z",
    stroke: "black",
    strokeWidth: 1.13889
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4377 34.7959C34.3499 25.1719 21.9235 18.8013 17.1055 17.2641C30.148 2.52405 46.4402 1.71125 62.39 0.915526L62.7359 0.898261C75.7823 0.246789 99.9635 1.07579 112.321 6.91334C127.177 13.9308 135.407 26.5623 139.222 38.3917C143.036 50.2212 143.839 70.4716 142.233 80.697C140.331 92.8057 136.822 112.308 119.95 117.188C101.28 122.588 77.5914 120.783 57.7172 116.185C40.1373 112.118 38.2449 92.7444 37.4417 84.5224L37.4415 84.5197C36.6385 76.2992 39.0475 46.8258 36.4377 34.7959Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.36667
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85.5625,
    y: 94.5312,
    width: 18.9475,
    height: 4.88968,
    rx: 1.48056,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8241 89.3543C54.1749 82.5632 42.7923 81.876 37.582 82.4823C38.1832 94.205 38.9848 100.066 44.1951 107.343C48.3348 113.123 55.0166 116.034 62.0304 116.842V100.268C62.0304 93.5987 59.8261 91.0386 58.8241 89.3543Z",
    stroke: "black",
    strokeWidth: 1.36667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8579 36.7049C27.6681 33.4673 19.8074 29.0938 15.5402 26.9922L10.9922 39.2608C14.0916 39.6698 24.973 45.5656 30.1948 55.1079L32.3846 43.6912C32.2723 42.9528 31.8668 39.6751 29.8579 36.7049Z",
    fill: "#CAA2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1131 113.834L8.54688 97.2812L9.6702 99.357L10.954 101.592C12.6619 104.133 15.2739 108.053 19.5425 111.652C22.9582 114.531 25.702 116.407 32.5334 119.625L40.7882 123.869L61.5694 124.48L84.7954 125.244L104.354 125.855L117.19 119.285L118.565 118.215C102.858 122.479 74.0768 120.78 57.5107 117.731L34.1131 113.834Z",
    fill: "#7057F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1106 126.926H62.7045L71.8086 136.4L50.1106 126.926Z",
    fill: "#383740"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3753 85.3633H7.01953L8.54762 90.09L25.8659 90.253C26.6809 89.2098 26.7149 86.5585 26.3753 85.3633Z",
    fill: "#826CF7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8609 127.539H66.1643L75.7812 137.93L52.8609 127.539Z",
    fill: "#634AE4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1094 124.48L106.037 126.556L99.0235 130.291L96.619 131.536L95.0159 132.366L75.3785 141.289L65.9605 137.346L56.5426 132.988L39.1094 124.48Z",
    fill: "#7057F0",
    stroke: "black",
    strokeWidth: 0.911111
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1102 127.539H65.3297L74.5586 137.93L50.1102 127.539Z",
    fill: "#644AE7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0276 74.3633H86.174V81.3922L75.0194 97.5893L54.5438 83.3786L44.9173 81.3922L38.6523 78.1833L40.0276 74.3633Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.407 44.4141H87.7018V35.3505L76.5113 14.4647L55.9699 32.789L46.3124 35.3505L40.0273 39.4882L41.407 44.4141Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8047,
    y: 46.2461,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.0039,
    y: 44.4141,
    width: 7.02892,
    height: 28.1157,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0236 73.5959L42.1633 69.1646L42.7746 71.4567L44.1493 73.1369L45.6773 74.0537L47.2053 74.5121L43.3584 77.172L40.0236 73.5959Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6205 74.3256L88.8339 68.2877L88.1601 69.472L87.8544 71.0001L87.0304 72.5281L85.7152 73.5977L84.34 74.2089L83.1176 74.5145L81.8952 75.3942L87.0304 79.0789L91.6205 74.3256Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2151 74.0547H137.361V81.0836L126.207 97.2807L105.731 83.07L96.1048 81.0836L89.8398 77.8748L91.2151 74.0547Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5945 44.1055H138.889L134.611 35.0419L120.247 17.9762L107.157 32.4804L97.4999 35.0419L91.2148 39.1796L92.5945 44.1055Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 89.9922,
    y: 45.9414,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.215 73.2912L93.3547 68.8599L93.966 71.152L95.3407 72.8322L96.8687 73.7491L98.3968 74.2075L94.5498 76.8673L91.215 73.2912Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140.876 74.2098L140.021 67.983L139.348 69.1674L139.042 70.6954L138.218 72.2234L136.903 73.293L135.527 73.9042L134.305 74.2098L133.083 75.0895L138.218 78.7742L140.876 74.2098Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1609 44.412H120.092H134.456L136.748 46.5513L138.581 48.9961L138.887 42.2728L134.456 35.3484L119.328 17.0603L102.724 32.787L93.0663 35.3484L86.7812 39.4861L88.1609 44.412Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2151 74.3633H137.361V81.3922L126.207 97.5893L105.731 83.3786L96.1048 81.3922L89.8398 78.1833L91.2151 74.3633Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7421 77.4606L97.2715 74.9087L96.187 74.2915L94.7876 74.0116L93.3883 73.257L92.4087 72.0526L91.849 70.7931L91.5691 69.6737L90.7635 68.5542L87.3891 73.257L91.7421 77.4606Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 88.3125,
    y: 45.3281,
    width: 3.66726,
    height: 28.1157,
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M138.125 43.9531L139.959 45.7868L141.792 59.2334V66.7207L141.487 72.2216L140.264 79.4033L133.388 76.5001L132.93 74.8193L135.222 73.7496L137.667 71.916V56.4829V48.9956L138.125 43.9531Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1777_12328)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.4688,
    y: 44.4141,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1777_12328)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.237,
    cy: 60.1523,
    rx: 19.1003,
    ry: 12.9882,
    fill: "#6B05D3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1777_12328)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.527,
    cy: 60.2755,
    rx: 14.5778,
    ry: 9.90833,
    fill: "#4DA2FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.5911 52.8612C70.6138 54.1291 71.614 55.4168 72.6649 56.6612C74.2377 58.5225 75.0485 60.6489 74.831 63.0829C74.5343 66.414 72.8589 68.8809 69.8256 70.2828C65.1479 72.4451 59.7489 70.1253 58.0688 65.2432C57.0904 62.3932 57.5038 59.6621 59.3496 57.2678C61.2915 54.7499 63.3511 52.3216 65.3579 49.8527C65.535 49.6348 65.6885 49.3961 65.8787 49.1923C66.1104 48.9433 66.3496 48.9197 66.5869 49.2188C66.8581 49.5612 67.152 49.8867 67.4345 50.2197C68.1062 51.1378 68.8261 52.0195 69.5911 52.8612ZM59.9091 64.283L59.9599 64.4245C59.9585 64.4711 59.9987 64.5534 60.0088 64.5989C61.1982 68.0894 65.5039 69.9338 68.8499 68.3942C69.0769 68.2894 69.1899 68.1734 69.1984 67.9111C69.2323 66.8545 68.9695 65.896 68.3442 65.0376C67.5861 63.9998 66.5549 63.3036 65.4653 62.664C63.8898 61.7347 62.5883 60.5489 61.9545 58.7668C61.8217 58.3895 61.7247 58.0046 61.5947 57.5678C60.5936 58.6055 59.9391 59.7621 59.7112 61.1291C59.5342 62.2064 59.5794 63.1509 59.9091 64.283ZM71.2975 66.5338C71.4567 66.3508 71.5462 66.263 71.6177 66.163C72.4604 64.9658 72.8862 63.524 72.8294 62.0602C72.7725 60.5964 72.2362 59.192 71.3032 58.064C70.2673 56.8093 69.2426 55.5414 68.2143 54.2791C67.6994 53.6458 67.1852 53.0124 66.6717 52.3791C66.4419 52.0961 66.1603 51.9461 65.8863 52.2725C65.2421 53.0385 64.5527 53.7763 64.1911 54.7404C63.5893 56.3442 63.5827 57.8772 64.6997 59.28C65.2948 60.0281 66.0708 60.5564 66.8911 61.0291C68.137 61.7489 69.2455 62.6329 70.1166 63.7923C70.7052 64.5847 71.0762 65.4762 71.2975 66.5338Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1777_12328)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.9805,
    y: 44.4141,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1777_12328)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.745,
    cy: 60.1523,
    rx: 19.1003,
    ry: 12.9882,
    fill: "#6B05D3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1777_12328)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.635,
    cy: 60.0492,
    rx: 13.6667,
    ry: 9.225,
    fill: "#4DA2FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.7 52.6346C120.723 53.9025 121.723 55.1903 122.774 56.4346C124.347 58.2959 125.158 60.4223 124.94 62.8563C124.644 66.1874 122.968 68.6544 119.935 70.0563C115.257 72.2185 109.858 69.8987 108.178 65.0167C107.2 62.1667 107.613 59.4355 109.459 57.0412C111.401 54.5233 113.46 52.095 115.467 49.6261C115.644 49.4082 115.798 49.1695 115.988 48.9658C116.22 48.7167 116.459 48.6931 116.696 48.9922C116.968 49.3346 117.261 49.6601 117.544 49.9931C118.216 50.9112 118.935 51.7929 119.7 52.6346ZM110.018 64.0564L110.069 64.1979C110.068 64.2445 110.108 64.3268 110.118 64.3723C111.308 67.8629 115.613 69.7072 118.959 68.1676C119.186 68.0629 119.299 67.9468 119.308 67.6846C119.342 66.628 119.079 65.6695 118.454 64.811C117.695 63.7733 116.664 63.077 115.575 62.4374C113.999 61.5082 112.698 60.3223 112.064 58.5403C111.931 58.1629 111.834 57.778 111.704 57.3412C110.703 58.3789 110.049 59.5355 109.821 60.9025C109.644 61.9799 109.689 62.9243 110.018 64.0564ZM121.407 66.3072C121.566 66.1242 121.656 66.0365 121.727 65.9365C122.57 64.7392 122.996 63.2974 122.939 61.8336C122.882 60.3698 122.346 58.9655 121.413 57.8374C120.377 56.5827 119.352 55.3148 118.324 54.0525C117.809 53.4192 117.295 52.7859 116.781 52.1526C116.551 51.8695 116.27 51.7195 115.996 52.046C115.351 52.812 114.662 53.5497 114.3 54.5139C113.699 56.1176 113.692 57.6506 114.809 59.0535C115.404 59.8016 116.18 60.3299 117 60.8025C118.246 61.5223 119.355 62.4063 120.226 63.5657C120.815 64.3582 121.186 65.2497 121.407 66.3072Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1777_12328",
    x: 35.3401,
    y: 36.3674,
    width: 59.7926,
    height: 47.5699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.39833,
    result: "effect1_foregroundBlur_1777_12328"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1777_12328",
    x: 43.592,
    y: 43.01,
    width: 43.8707,
    height: 34.5309,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.67861,
    result: "effect1_foregroundBlur_1777_12328"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1777_12328",
    x: 84.8479,
    y: 36.3674,
    width: 59.7926,
    height: 47.5699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.39833,
    result: "effect1_foregroundBlur_1777_12328"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1777_12328",
    x: 94.6115,
    y: 43.467,
    width: 42.0465,
    height: 33.1637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.67861,
    result: "effect1_foregroundBlur_1777_12328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1777_12328",
    x1: 16.1886,
    y1: 19.5047,
    x2: 55.7102,
    y2: 140.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B589FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491707,
    stopColor: "#AF86FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738033,
    stopColor: "#866FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806CF5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1777_12328"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.4688,
    y: 44.4141,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1777_12328"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.9766,
    y: 44.4141,
    width: 45.5352,
    height: 29.9493,
    rx: 3.87222,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingBotLogo2);
export default __webpack_public_path__ + "static/media/TradingBotLogo_2.150180fd2d80afde7f7b9a2a8703dbb5.svg";
export { ForwardRef as ReactComponent };